// Created by AI
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["messageInput"]
  static values = {
    aiChatId: String
  }
  /*
    connect() {
      this.element.addEventListener("turbo:submit-start", this.handleSubmitStart.bind(this))
      this.element.addEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this))
      this.element.addEventListener("submit", this.handleSubmit.bind(this))
    }
  
    disconnect() {
      this.element.removeEventListener("turbo:submit-start", this.handleSubmitStart)
      this.element.removeEventListener("turbo:submit-end", this.handleSubmitEnd)
      this.element.removeEventListener("submit", this.handleSubmit)
    }
  
    handleSubmit(event) {
      // Prevent default form submission behavior if the input is empty
      if (!this.messageInputTarget.value.trim()) {
        event.preventDefault()
        return false
      }
      return true
    }
  
    handleSubmitStart(event) {
      // Save the message in a temporary variable
      this.lastMessage = this.messageInputTarget.value
  
      // Append the user's message immediately to the chat window
      const chatMessages = document.getElementById(`chat-${this.aiChatIdValue}-messages`)
      const userMessageHtml = `
        <div class="mb-4 text-right">
          <div class="inline-block max-w-[75%] bg-blue-100 text-left p-3 rounded-lg shadow-sm">
            <div class="text-xs text-medium-gray mb-1">
              ${document.querySelector('meta[name="current-user-name"]')?.content || 'You'} • just now
            </div>
            <div class="">
              ${this.lastMessage}
            </div>
          </div>
        </div>
      `
      chatMessages.insertAdjacentHTML('beforeend', userMessageHtml)
  
      // Add "AI is typing" indicator
      const typingIndicator = document.createElement('div')
      typingIndicator.id = 'typing-indicator'
      typingIndicator.className = 'mb-4'
      typingIndicator.innerHTML = `
        <div class="inline-block max-w-[75%] bg-white p-3 rounded-lg shadow-sm">
          <div class="text-xs text-medium-gray mb-1">
            AI Assistant • just now
          </div>
          <div class="whitespace-pre-wrap flex items-center">
            <span class="mr-1">Thinking</span>
            <span class="typing-dot">.</span>
            <span class="typing-dot">.</span>
            <span class="typing-dot">.</span>
          </div>
        </div>
      `
      chatMessages.appendChild(typingIndicator)
  
      // Scroll to bottom
      chatMessages.scrollTop = chatMessages.scrollHeight
  
      // Clear the input field
      this.messageInputTarget.value = ''
    }
  
    handleSubmitEnd(event) {
      // Remove the typing indicator when response comes back
      const typingIndicator = document.getElementById('typing-indicator')
      if (typingIndicator) {
        typingIndicator.remove()
      }
  
      // If there was an error in the response, show it
      if (event.detail.error) {
        console.error('Error sending message:', event.detail.error)
  
        // Show error in chat
        const chatMessages = document.getElementById(`chat-${this.aiChatIdValue}-messages`)
        const errorMessageHtml = `
          <div class="mb-4">
            <div class="inline-block max-w-[75%] bg-red-100 text-left p-3 rounded-lg shadow-sm">
              <div class="text-xs text-medium-gray mb-1">
                System • just now
              </div>
              <div class="">
                There was an error processing your message. Please try again.
              </div>
            </div>
          </div>
        `
        chatMessages.insertAdjacentHTML('beforeend', errorMessageHtml)
        chatMessages.scrollTop = chatMessages.scrollHeight
      }
  
      // Re-focus the input
      this.messageInputTarget.focus()
    }
  */
}